import { render, staticRenderFns } from "./a-home-icon.vue?vue&type=template&id=941bf85a&"
import script from "./a-home-icon.vue?vue&type=script&lang=js&"
export * from "./a-home-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports